/**
 * Self-contained build-time feature flag for the RESPONSIVE (mobile web) wheel
 * share-view SEGMENT-LOAD PERFORMANCE fixes.
 *
 * User report: on the mobile responsive share view "the segments are taking a long
 * time to load and until they do you cant scroll the segment." Measured on prod
 * (evidence/prod-measure-chromium.json) the dominant cost is the initial JS bundle
 * (~21MB) gating first paint (~8.5s) — a separate, larger effort (PERF-001). This
 * flag carries the SMALL, in-scope, segment-level wins that reduce per-segment
 * open cost + main-thread work on a content-heavy wheel:
 *   1. Lazy-load + async-decode segment CONTENT images (CodeBlocks/Image), so
 *      off-screen images inside an open segment don't block the first paint /
 *      the scroll container becoming interactive.
 *   2. Memoize the SegmentView `isSegmentEmpty()` nodes parse so a large segment's
 *      craft node string is not re-parsed on every re-render during load.
 *
 * When OFF, the touched surfaces are BYTE-IDENTICAL to today (images render with
 * no loading/decoding attr; the empty-check parses inline exactly as before).
 *
 * WHY ITS OWN FILE: mirrors the sibling per-surface flags; can be reviewed /
 * merged / rolled out independently, and folded into constants/featureFlags.js
 * at merge.
 *
 * Flag-name collision audit: REACT_APP_RESPONSIVE_PERF is a new, unique name — no
 * existing REACT_APP_* var uses the RESPONSIVE_PERF token.
 */
const truthy = (v) => v === "true" || v === "1" || v === true;

export const RESPONSIVE_PERF_ENABLED = truthy(
  process.env.REACT_APP_RESPONSIVE_PERF
);
